module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outline"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('img', {
    staticClass: "picture",
    attrs: {
      "src": require("./../assets/photo.jpg")
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.basics.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basics.label))])]), _vm._v(" "), _c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-section"
  }, [_c('h2', [_vm._v("Skype")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basics.skype))]), _vm._v(" "), _c('h2', [_vm._v("E-mail")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basics.email))]), _vm._v(" "), _c('h2', [_vm._v("Phone")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.basics.phone))])])]), _vm._v(" "), _c('section', [_vm._m(1), _vm._v(" "), _vm._l((_vm.basics.profiles), function(profile) {
    return _c('div', {
      staticClass: "body-section"
    }, [_c('h2', [_vm._v(_vm._s(profile.network))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(profile.url))])])
  })], 2), _vm._v(" "), _c('section', [_vm._m(2), _vm._v(" "), _vm._l((_vm.skills), function(skill) {
    return _c('div', {
      staticClass: "body-section"
    }, [_c('h2', [_vm._v(_vm._s(skill.name))]), _vm._v(" "), _c('progress-bar', {
      attrs: {
        "percentage": skill.level
      }
    }), _vm._v(" "), _vm._l((skill.keywords), function(tech) {
      return _c('p', {
        staticClass: "skill"
      }, [_vm._v("\n        " + _vm._s(tech) + "\n      ")])
    })], 2)
  })], 2), _vm._v(" "), _c('section', [_vm._m(3), _vm._v(" "), _vm._l((_vm.languages), function(language) {
    return _c('div', {
      staticClass: "body-section"
    }, [_c('p', [_vm._v(_vm._s(language.name) + " - " + _vm._s(language.level))])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Personal Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Social media")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Skills")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Languajes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d0592c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Outline.vue
// module id = 18
// module chunks = 0